import React from 'react';
import { RecommendedProduct } from './RecommendedProduct';
import "./subscriber-recommendations.scss";
import WebUtils from '../../../services/WebUtils';
import Config, { DeploymentType, IConfig, SourceApp } from "../../../Config";




export interface IProps {
    deploymentType: DeploymentType;
    sourceApp: SourceApp;
}
export interface IState {
    recommendedProducts: any[];
    finishedLoading: boolean;
}

export class Recommendations extends React.Component <IProps, IState> {
    private webUtils: WebUtils;
    private config: IConfig;

    constructor(props: IProps) {
        super(props);
        this.config = Config.getConfig(this.props.sourceApp, this.props.deploymentType);
        this.webUtils = new WebUtils(this.config);
        this.fetchData();
    }

    private fetchData() {
        let url = "manningOnline/getSubscriberRecommendations"

        this.webUtils.ajax(
            this.webUtils.getAbsoluteBackendUrl(url).replace("3001", "8080"),
            (data: any) => {
                this.setState({recommendedProducts: data, finishedLoading: true});
            },
            error => {
                console.error('There was a problem with the fetch operation: ', error);
                this.setState({recommendedProducts: [], finishedLoading: true});
            },
            {}, 
            false, true
        );
    }

    public render(){

        const firstFourItems = this?.state?.recommendedProducts ? this.state.recommendedProducts.slice(0, 4) : null;
        
        return <div className="you-might-be-interested-in">
                    <div className="you-might-be-interested-in-intro">suggested for you</div>
                    { !this?.state?.finishedLoading && <div className="you-might-be-interested-in-loading"><i className="fas fa-spinner fa-spin"></i></div>}
                    { this?.state?.finishedLoading && firstFourItems.length === 0 && <div className="you-might-be-interested-in-no-results">No recommendations available yet. Once you start reading we'll give you recommendations based on your reading.</div>}
                    { this?.state?.finishedLoading && firstFourItems.length > 0 && 
                        <div className="you-might-be-interested-in-content">
                            { firstFourItems.map((item: any, index: number) => {
                                return <RecommendedProduct key={index} image={item.coverPath} 
                                    title={item.title} 
                                    chapterTitle={item.chapterTitle} 
                                    chapterLink={item.chapterLink}
                                    blurb={item.blurb}
                                    bookShortName={item.bookShortName}
                                    elementShortName={item.elementShortName}
                                    recommendationBasedOnTitle={item.recommendationBasedOnTitle}
                                    recommendationBasedOnCover={item.recommendationBasedOnCover}
                                    authors={item.authors}
                                    publicationDate={item.publicationDate}
                                    deploymentType={this.props.deploymentType}
                                    sourceApp={this.props.sourceApp}
                                    />
                            })}
                        </div>
                    }
               </div>
    }
}